import { track } from '@eventbrite/datalayer-library';
import { HeapEventName } from '../../../constants/heap';

export const trackOnCreateOrderError = (error) => {
    let errorType = null;

    try {
        errorType = JSON.parse(error?.extraData?.parsedError)?.error;
    } catch (e) {}

    track({
        eventName: HeapEventName.createOrderError,
        eventData: { type: errorType },
    });
};
